import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import server from '../../assets/server.svg';

const PageError = () => {
    return(
        <main>
        <Container fluid>
            <div>
                <Row className="justify-content-md-center">
                    <Col  sm={12} md={12} lg={12} className="d-none d-lg-block" style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                        <br></br>
                        <h3>Erro encontrado, contate o administrador do sistema!</h3>
                        <br></br>
                        <img src={server} alt="Server error" style={{width: '365px'}} />
                    </Col>
                </Row>
                <br></br>
                <br></br>
                <Row>
                    <Col sm={12} md={12} lg={12} className="d-none d-lg-block" style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                        <Link className="btn btn-primary" to="/home">Página Inicial</Link>
                    </Col>
                </Row>
            </div>
        </Container>
        </main>
    );
}

export default PageError;